import { Separator } from "@/components/ui/separator";

export default function TermsPage({ settings }) {
  const name = settings?.business_name || "PennyMacs";
  return (
    <div data-testid="terms-page">
      <section className="hero-gradient py-16 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#1d1d1f] tracking-tight">
            Terms of Service
          </h1>
          <p className="mt-3 text-sm text-[#86868b]">Last updated: February 2026</p>
        </div>
      </section>
      <section className="py-12 sm:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-8">
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Agreement</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              By purchasing from {name}, you agree to these terms. Each MacBook listed is a unique, pre-owned item with a quantity of one. All sales are final once an item is marked as sold.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Products</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              All MacBooks are pre-owned and have been professionally tested. Product descriptions and condition ratings are provided in good faith. Photos represent the actual item being sold.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Pricing & Tiers</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              Prices are listed in USD. The "Basic" tier includes the MacBook and charger. The "With Extended Warranty" tier additionally includes a 90-day warranty. Prices are final and include the selected tier's inclusions.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Warranty</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              The 90-day extended warranty covers hardware defects only. It does not cover accidental damage, water damage, or software issues. Warranty claims must be initiated by contacting us directly.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Limitation of Liability</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              {name} provides products "as-is" within the described condition rating. Our liability is limited to the purchase price of the product.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
